<template>
  <right-structure :Pdatas='infoData'>
  </right-structure>
</template>

<script>
  import structure from "@/components/flowStructure"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
      return {
        requestBody: null,
        responseCode: null,
        infoData: {
          flow: [
            {
              name: '无牌车自助进出',
              desc: [
                '1、无牌车进场',
                {
                  preData: "在入口扫第三方通道码，第三方获取到用户的ID和通道ID后，通过对接",
                  link:  "扫通道二维码自助进出场",
                  url: "scanChannelCodeInOut",
                  endData: " 接口（把获取到“用户ID、通道ID、用户的唯一编码（第三方定义）”给到场端系统）获取随机码并保存，车场开闸放行。"
                },
                '2、无牌车离场：',
                [
                  {
                    preData: "无牌车离场，用户扫第三方通道码，第三方获取到用户ID及通道ID后，通过对接 ",
                    link:  "扫通道二维码自助进出场",
                    url: "scanChannelCodeInOut",
                    endData: " 接口（把获取到“用户ID、通道ID、用户的唯一编码（第三方定义）”给到场端系统），获取“随机码/停车唯一编号（停车记录号）”，"
                  },
                  {
                    preData: "然后调 ",
                    link:  "查费",
                    url: "getParkFee",
                    endData: " 接口，获取车辆的停车费，扣费成功后，"
                  },
                  {
                    preData: "通过调 ",
                    link:  "缴费",
                    url: "payParkFee",
                    endData: " 接口向车场同步账单，停车场接收到账单后核对金额无误，开闸放行。"
                  },
                ]

              ],
              url: '/static/img/scanChannelCodeInOut.svg'
            },
            {
              name: '有牌车自助进出',
              desc: [
                '1、有牌车进场',
                {
                  preData: "有牌车正常识别进场",
                  link:  "",
                  url: "",
                  endData: ""
                },
                '2、有牌车离场：',
                [
                  {
                    preData: "设备展示当前车辆费用——>车主扫第三方通道码支付费用——>第三方获取到用户ID及通道ID后，通过对接 ",
                    link:  "扫通道二维码自助进出场",
                    url: "scanChannelCodeInOut",
                    endData: " 接口（把获取到“用户ID、通道ID、用户的唯一编码（第三方定义，不可重复）”给到场端系统）获取“车牌号/停车记录号”，"
                  },
                  {
                    preData: "——>然后调 ",
                    link:  "查费",
                    url: "getParkFee",
                    endData: " 接口，用“停车记录号parkingcode”获取车辆的停车费，"
                  },
                  {
                    preData: "扣费成功后——>通过调 ",
                    link:  "缴费",
                    url: "payParkFee",
                    endData: " 接口向车场同步账单，停车场接收到账单后核对金额无误，开闸放行。"
                  },
                ]

              ],
            }
          ],
        }
      }
    },
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/parking/scanChannelCodeInOutFlow.vue